import React, { useEffect, useState } from 'react';
import PartnerListTable from "./partners/InsurancePartnerTable";
import { getPartnerMappingList } from '../store/slices/partner';
import { useDispatch, useSelector } from 'react-redux'
import FullPageLoader from '../common/FullPageLoader';
import { getMasterConfig } from '../store/slices/common';
import AddEditInsurancePartner from './partners/AddEditInsurancePartner';
import * as HELPER from "../config/helper";
import { PAGE_NUMBER, ROLE_FEATURES, STATUS_SUCCESS } from '@src/config/constant';


export default function InsurancePartnerManagement(props: any): ReturnType<React.FC> {
    let [showAddInsPartnerIcon, setShowAddInsPartnerIcon] = useState<boolean>(false)
    let [partnerMappingList, setPartnerMappingList] = useState<any>([])
    let [loading, setLoading] = useState<boolean>(false)
    let [insuranceTypeList, setInsuranceTypeList] = useState<[]>([])
    let [methodList, setMethodList] = useState<[]>([])
    let [vehicletypeList, setVehicletypeList] = useState<[]>([])
    let [paymentTypeList, setPaymentTypeList] = useState<[]>([])
    let [contractStatusList, setContractStatusList] = useState<[]>([])


    const dispatch: any = useDispatch()
    const commonState = useSelector((state: any) => state.common)

    const showModalAddInsurance = () => {
        setShowAddInsPartnerIcon(true)
    }

    const hideModalAddInsurance = () => {
        setShowAddInsPartnerIcon(false)
    }

    /**
     * function for API Call
     * fetches Partner Mapping List
     * @param params 
     */
    const getPartnerMappings = (params?: { page_number: number }) => {
        setLoading(true)

        let filters = {
            page_number: params?.page_number ?? PAGE_NUMBER
        }

        dispatch(getPartnerMappingList(filters)).then((res: any) => {
            if (res && res.status === STATUS_SUCCESS) {
                const partnerMappingList = res
                setPartnerMappingList(partnerMappingList)
            }
            setLoading(false)

        }).catch((err: Error) => {
            setLoading(false)

        })


    }

    const fetchPartnerMappings = (params: any) => {
        getPartnerMappings(params)
    }

    /**
     * API call for rendering static dropdowns 
     */
    // const getConfig = async () => {


    // }

    const handleLoader = (input: boolean) => {
        setLoading(input)
    }

    useEffect(() => {
        getPartnerMappings() // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (commonState && commonState.common && Object.keys(commonState.common).length) {
            let data = commonState.common
            let { apptype, insurance_type, both,vehicle_type, payment_type, contract_status } = data
            let updatedRuleEngine: any = []

            //pushing both in dropdowns
            if (both) {
                updatedRuleEngine.push(both)
                insurance_type = (insurance_type && insurance_type.length) ? [...insurance_type, both] : []
            }
            if(vehicle_type.length){
                vehicle_type= vehicle_type.map((el:any)=>({value:el.value,label:`${el.label}(${el.vehicle_usage_name})`}))
            }
            setMethodList(apptype)
            setInsuranceTypeList(insurance_type)
            setVehicletypeList(vehicle_type)
            setPaymentTypeList(payment_type)
            setContractStatusList(contract_status)
            
        }
        else {
            //api call to fetch static dropdowns
            dispatch(getMasterConfig()).then((res: any) => {
                if (res && res.status === STATUS_SUCCESS) {
                    let data: any = res.data || {}
                    let { apptype, insurance_type, both,vehicle_type, payment_type, contract_status } = data

                    //pushing both in dropdowns
                    if (both) {
                        insurance_type = (insurance_type && insurance_type.length) ? [...insurance_type, both] : []
                    }
                    if(vehicle_type.length){
                        vehicle_type= vehicle_type.map((el:any)=>({value:el.value,label:`${el.label}(${el.vehicle_usage_name})`}))
                    }
                    setMethodList(apptype)
                    setInsuranceTypeList(insurance_type)
                    setVehicletypeList(vehicle_type)
                    setPaymentTypeList(payment_type)
                    setContractStatusList(contract_status)
                }
            }).catch((err: Error) => {
            })
        }
    }, [dispatch, commonState])

    return (
        <div className="container-fluid">
            <div className="top-heading financer-lead-heding">
                <h1>Insurance Partner Management</h1>
                {HELPER.isUserHasAccessPage({permissionID: ROLE_FEATURES['insurance_partner_management'], accessType: 'edit'}) && <button className="btn-line" onClick={showModalAddInsurance}>
                    <i className="ic-add"></i>
                    <span>Add Insurance Partner</span>
                </button>}
            </div>

            <FullPageLoader show={loading} />

            <PartnerListTable apiResponse={partnerMappingList} getPartnerMappings={fetchPartnerMappings} loading={loading} insuranceTypeList={insuranceTypeList} methodList={methodList} vehicletypeList={vehicletypeList} handleLoader={handleLoader} paymentTypeList={paymentTypeList} contractStatusList={contractStatusList}/>

            <AddEditInsurancePartner callFrom={'AddInsurancePartner'} showAddInsPartnerIcon={showAddInsPartnerIcon} handleModalClose={hideModalAddInsurance} insuranceTypeList={insuranceTypeList} methodList={methodList} fetchPartnerMappings={fetchPartnerMappings} handleLoader={handleLoader} updateSelectedPartner={()=>{}} vehicletypeList={vehicletypeList}/>

        </div>
    )
}

